// 记录路由后缀，和youtube官网进行拼接

const STORAGE_KEY = "VIEMAO_REDIRECTED_INFO";

export function setRedirectedInfo(info) {
    sessionStorage.setItem(STORAGE_KEY, info);
}

export function getRedirectedInfo() {
    return sessionStorage.getItem(STORAGE_KEY);
}

export function clearRedirectedInfo() {
    sessionStorage.removeItem(STORAGE_KEY);
}
